import { render, staticRenderFns } from "./formQuestion.vue?vue&type=template&id=564d26d8&scoped=true"
import script from "./formQuestion.vue?vue&type=script&lang=ts"
export * from "./formQuestion.vue?vue&type=script&lang=ts"
import style0 from "./formQuestion.vue?vue&type=style&index=0&id=564d26d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d26d8",
  null
  
)

export default component.exports